import { Flex, Span } from '@fareye/ui'
import React from 'react'
import { Stage, Details, IconLine, Icon, Line } from '../../../style/styled'
import FieldValue from './FieldValue'
import PoiDetails from './PoiDetails'

export default (props: any) => {
  const {
    name,
    style,
    eta,
    icon,
    line,
    stoppages,
    overspeeding,
    exitDatetime,
    enterDatetime,
    tripRunningStatus
  } = props

  const [stoppage, setStoppage] = React.useState(null)
  const [poiDetails, setPoiDetails] = React.useState(null)
  const iconSize = 20
  return (
    <Stage column style={style && style.stage}>
      <Details column>
        {name ? (
          <Span style={style && style.name} variant="ellipsis">
            {name}
          </Span>
        ) : (
          <Span variant="ellipsis">&nbsp;</Span>
        )}
      </Details>
      {/* {stoppage && (
        <Stoppages close={() => setStoppage(null)} stoppages={stoppages} />
      )} */}
      <PoiDetails poiDetails={poiDetails} close={() => setPoiDetails(null)} />
      <IconLine style={style && style.iconLine}>
        {line && (
          <Line
            borderColor={line.color}
            width={line.width}
            borderStyle={line.style}
            style={{ top: `${iconSize / 2}px` }}
          />
        )}
        <Icon
          onClick={() => setPoiDetails(props)}
          style={style && style.iconWrapper}
        >
          {icon}
        </Icon>
        <Flex
          width={1}
          style={{ position: 'absolute', top: `${iconSize * 0.25}px` }}
          justifyContentSpaceAround
        >
          {/* {stoppages && stoppages.length > 0 && (
            <FaStopCircle
              onClick={() => setStoppage(stoppages)}
              title={`${stoppages.length} Stoppage`}
              style={{
                zIndex: 3,
                background: '#fff'
              }}
              color="#d6e92a"
              size={iconSize * 0.8}
            />
          )} */}
          {/* {overspeeding > 0 && typeof overspeeding === 'number' && (
            <FaExclamationTriangle
              title={`${overspeeding} Overspeeding${
                overspeeding > 1 ? 's' : ''
              }`}
              style={{
                zIndex: 3,
                background: '#fff'
              }}
              color="#e92a2a"
              size={iconSize * 0.8}
            />
          )} */}
        </Flex>
      </IconLine>
      <Details column>
        <FieldValue style={{ maxWidth: 120 }} value={eta && `${eta}`} />
        <FieldValue
          style={{
            maxWidth: 90,
            justifyContent: 'center',
            color: tripRunningStatus
              ? tripRunningStatus.status === '+'
                ? 'red'
                : 'green'
              : 'inherit'
          }}
          value={`${
            tripRunningStatus
              ? `${tripRunningStatus.status} ${tripRunningStatus.duration}`
              : ''
          }`}
        />
      </Details>
    </Stage>
  )
}
